require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-world-credit-union-conference.json") })
        }
      }, "path---articles-tags-world-credit-union-conference");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-world-credit-union-conference!./.cache/json/articles-tags-world-credit-union-conference.json
// module id = 1917
// module chunks = 231608221292675